import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgVeryDryGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m27.125 26.332-1.146.732 1.914 3 1.147-.731-1.915-3Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "m36.328 34.688-.12-1.35-2.96.273c.24-2.765.587-5.997.936-8.99l3.145-.305-.13-1.35-2.852.272c.533-4.539 1.023-8.218 1.045-8.305.196-1.534-.457-2.993-1.796-4.005a5.54 5.54 0 0 0-.805-.5l.63-2.025L32.128 8l-.61 1.948a6.3 6.3 0 0 0-3.984.316c-2.666 1.121-3.896 5.16-4.386 9.252-.49-1.317-1.186-2.46-2.177-3.135-1.186-.806-2.601-.87-4.223-.207-2.721 1.121-3.712 4.234-3.842 7.891l-1.002-.49-.62 1.209 1.59.773c.043 2.122.326 4.342.696 6.432L11 32.37l.196 1.35 2.623-.392c.5 2.536 1.088 4.756 1.458 6.182l.131.49 1.317-.337-.13-.501a92.385 92.385 0 0 1-1.394-6.03l1.491-.218-.195-1.35-1.535.23c-.37-2.134-.588-3.974-.664-5.54l2.122 1.033.599-1.219-2.754-1.339c.022-4.767 1.437-6.661 2.994-7.303 1.186-.49 2.155-.468 2.938.076 1.785 1.208 2.493 4.865 2.689 7.87.01.478.032.936.065 1.35.01.336.01.663 0 .957-.044 2.96-.425 11.33-.425 11.418l1.361.065c0-.087.381-8.479.425-11.461v-1.034c-.011-.425-.033-.915-.066-1.48-.174-6.03 1.023-12.496 3.82-13.671a4.987 4.987 0 0 1 3.048-.262l-1.12 3.57 1.294.403 1.089-3.461c.13.076.272.163.392.25.936.708 1.404 1.71 1.262 2.743-.043.36-.544 4.093-1.077 8.61l-1.655.152.13 1.35 1.362-.13a324.756 324.756 0 0 0-.926 8.99l-4.68.424.12 1.35 4.451-.403c-.163 2.166-.228 3.918-.13 4.833l1.35-.13c-.088-.894-.011-2.646.152-4.834l3.2-.283Z",
    fill: "currentColor"
  }));
}

export { SvgVeryDryGlyph as default };
